import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  BackgroundLogin,
  ChevronRight,
  GrologLogo,
  LogoGrochat,
} from "../../asset";
import { ROUTES } from "../../constant/routeConstant";
import { useDispatch } from "react-redux";
import {
  setGrologAccInfo,
  setIsWaitingApprove,
  setToken,
} from "../../store/reducer/authentication.reducer";
import { BASE_URL, GROCHAT_URL } from "../../constant/apiConstant";
import * as LoginServices from "../../service/loginServices";
import { setIsCompletion } from "../../store/reducer/page.reducer";
import { useState } from "react";
import { SHA256 } from "crypto-js";
import { getHostname } from "../../util/getHostname";

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isWaiting, setIswaiting] = useState(false);

  const handleLogin = async () => {
    //untuk set request id dan code verifier
    const length = 6;
    const chars =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let randomString = "";

    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * chars.length);
      randomString += chars.charAt(randomIndex);
    }
    const newRandomString = randomString;
    const hash = SHA256(newRandomString).toString();
    localStorage.setItem("random_string", newRandomString);
    localStorage.setItem("first_req_id", hash);

    if (randomString && hash) {
      const { status, internal_token } = await LoginServices.getInternalToken();
      if (status) {
        getNewWindow(internal_token, hash);
      }
    }
  };

  const getNewWindow = (token, request_id) => {
    const link = `${GROCHAT_URL}/login?token=${token}&redirect_uri=${getHostname(
      window.location.href
    )}${
      ROUTES.LOGIN_SUCCESS
    }&resource_id=log&isRegister=true&cancel=${BASE_URL}&request_id=${request_id}`;
    window.open(link, "", "width=600,height=1000,left=200,top=200");
  };

  useEffect(() => {
    // getGenerate()
    loginPWA();
    // eslint-disable-next-line
  }, []);

  const loginPWA = () => {
    const loginTimer = setInterval(() => {
      const auth_code = localStorage.getItem("auth_code");
      const req_id = localStorage.getItem("request_id");
      const prev_req_id = localStorage.getItem("first_req_id");
      const code_verifier = localStorage.getItem("random_string");

      if (req_id !== null) {
        if (req_id === prev_req_id) {
          getToken(auth_code, req_id, code_verifier);
        } else {
          console.log("keluar kondisi");
        }
      }
    }, 2000);
    return () => clearInterval(loginTimer);
  };

  const getToken = async (auth_code, request_id, code_verifier) => {
    const body = { auth_code, request_id, code_verifier };

    const { status, data } = await LoginServices.authPWA(body);
    if (status) {
      dispatch(setToken(data?.token));
      dispatch(setIsCompletion(data?.is_completion_account));
      dispatch(setIsWaitingApprove(data?.is_waiting_approve));
      dispatch(setGrologAccInfo(data?.grochat_account_information));
      if (data?.is_completion_account && data?.is_invitation) {
        navigate(ROUTES.COMPLETION);
      } else if (data?.is_completion_account && !data?.is_invitation) {
        navigate(ROUTES.COMPLETION_DATA);
      } else if (data?.is_waiting_approve) {
        setIswaiting(true);
      } else {
        navigate(ROUTES.SELECT_PORTAL);
      }
    }
    localStorage.removeItem("auth_code");
    localStorage.removeItem("request_id");
    localStorage.removeItem("first_req_id");
    localStorage.removeItem("random_string");
  };

  return (
    <div className=" flex w-full h-screen">
      <div
        className="w-4/6"
        style={{
          backgroundImage: `url(${BackgroundLogin})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      ></div>
      <div className=" w-2/6 p-10 flex flex-col justify-center items-center gap-[100px]">
        <div className=" mt-5 text-center">
          <img
            width={300}
            src={GrologLogo}
            alt="grolog-logo"
            className="p-5 mx-auto"
          />
          <p className=" font-sans-bold text-black-700 leading-8 text-lg">
            Your Logistic Solution Partner
          </p>
        </div>
        <button
          onClick={handleLogin}
          className="w-[450px] h-[65px] border-[#C6C6C6] border-[2px] rounded-[12px] flex justify-center items-center gap-[24px]"
        >
          <img width={80} src={LogoGrochat} alt="" srcset="" />
          <p className=" font-sans font-[600] leading-8 text-lg">
            Login with Grochat Account
          </p>
          <img src={ChevronRight} alt="" />
        </button>
        {isWaiting
          ? "User anda sudah terdaftar, silahkan menunggu dari admin"
          : ""}
      </div>
    </div>
  );
};

export default Login;
